// src/login/LoginPage.jsx
import { Box, Paper, Typography, Button } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import kdsBackground from "../img/kds.jpg";
import logo from "../img/logo.png";

function LoginPage() {
  const { login, auth } = useAuth();
  const location = useLocation();

  // Where should we go AFTER login?
  // If we were redirected here by a protected route, it can set location.state.from.
  const from = location.state?.from || "/";

  // While auth is initializing, just show a loading state
  if (auth.loading) {
    return <div>Loading…</div>;
  }

  //  If we're already logged in, don't stay on /login
  // Send user back where they came from (or home)
  if (auth.isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  const handleLogin = () => {
    // Tell Keycloak to send us back to the original page after login
    login({
      redirectUri: `${window.location.origin}${from}`,
    });
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        backgroundImage: `url(${kdsBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 7,
          width: "80%",
          maxWidth: "400px",
          borderRadius: 3,
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(255,255,255,0.85)",
          textAlign: "center",
        }}
      >
        <Box mb={2} display="flex" justifyContent="center">
          <img
            src={logo}
            alt="MyODS Logo"
            style={{ width: "200px", height: "auto" }}
          />
        </Box>

        <Typography variant="h6" gutterBottom>
          Welcome to MyODS
        </Typography>

        <Button
          fullWidth
          variant="contained"
          onClick={handleLogin}
          sx={{ mt: 2 }}
        >
          Sign In with Keycloak
        </Button>

        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          sx={{ mt: 4 }}
        >
          © MyODS 2025
        </Typography>
      </Paper>
    </Box>
  );
}

export default LoginPage;
